import http from 'hub-http/clients/apiClient';
import { useMemo } from 'react';
import { registerQuery, useQuery } from 'data-fetching-client';
const contactCampaignGuidsQueryName = 'contactCampaignGuids';
export const getContactCampaignGuidsQuery = registerQuery({
  fieldName: contactCampaignGuidsQueryName,
  args: ['contactId'],
  fetcher: ({
    contactId
  }) => http.post('/campaigns/associations/assets/v3/contact-campaigns/', {
    data: {
      contactId
    }
  })
});
export const useContactInfluencedCampaigns = contactId => {
  const {
    data,
    loading,
    error
  } = useQuery(getContactCampaignGuidsQuery, {
    variables: {
      contactId
    }
  });
  const campaigns = useMemo(() => {
    if (!data) {
      return [];
    }
    return data.contactCampaignGuids;
  }, [data]);
  const hasData = campaigns.length > 0;
  return {
    campaigns,
    loading,
    hasData,
    error: error || null
  };
};